export enum FlowtagPages {
  Landing = 'landing',
  Education = 'education',
  PageName = 'pageName',
  ChooseExistingPage = 'ChooseExistingPage',
  NoExistingPage = 'NoExistingPage',
  Profile = 'profile',
  Contact = 'contact',
  Socials = 'socials',
  SignIn = 'signIn',
  SignUp = 'signUp',
  ActivatedSuccess = 'ActivatedSuccess',
  ActivationError = 'ActivationError',
  ReferralsSubmitted = 'ReferralsSubmitted',
  ReferralEmails = 'ReferralEmails',
  OffboardingVideo = 'OffboardingVideo',
  CodeClaimed = 'CodeClaimed'
}
